import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "disabled", "title", "tab-index", "aria-label", "onKeydown", "onKeyup"]

import { computed } from 'vue';
import { ArrowPathIcon } from '@heroicons/vue/24/outline'; // TODO: Удалить. Заменить на наш прелоадер

import { IButtonProps, ButtonType } from '@/@types/components/ui/buttons'

import '@/components/ui/buttons/SmButton/style.scss';

// [START] Props

export default /*#__PURE__*/_defineComponent({
  __name: 'SmButton',
  props: {
    type: {},
    nativeType: { default: 'button' },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    title: { default: null },
    tabIndex: { default: 0 },
    ariaLabel: { default: null },
    size: { default: 'auto' }
  },
  emits: ["click", "keydown.enter", "keydown.space"],
  setup(__props: any, { emit: emits }) {

const props = __props;


// [END] Props

// [START] Emits

// [END] Emits

// [START] Computed properties
const typeClassMap: Record<ButtonType, string> = {
  primary: ' button--primary',
  secondary: ' button--secondary',
  success: ' button--success',
  error: ' button--error',
  warning: ' button--warning',
  info: ' button--info',
  text: ' button--text',
};

const className = computed((): string => {
  const { type, loading, disabled, size } = props;

  let className = typeClassMap[type] || '';

  className += loading ? ' button--loading' : '';
  className += disabled ? ' button--disabled' : '';
  className += size === 'small' ? ' button--small' : '';
  className += size === 'middle' ? ' button--middle' : '';
  className += size === 'big' ? ' button--big' : '';
  className += size === 'auto' ? ' button--auto' : '';

  return className;
});

const disabled = computed((): boolean => props.loading || props.disabled);
const title = computed((): string => props.title || '');
const ariaLabel = computed((): string => props.ariaLabel || '');
// [END] Computed properties

// [START] Methods
const handleClick = (): void => emits('click');
const handleKeyDownEnter = (): void => emits('keydown.enter');
const handleKeyUpSpace = (): void => emits('keydown.space');
// [END] Methods

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: props.nativeType,
    class: _normalizeClass(["button", className.value]),
    disabled: disabled.value,
    title: title.value,
    role: "button",
    "tab-index": props.tabIndex,
    "aria-label": ariaLabel.value,
    onClick: handleClick,
    onKeydown: _withKeys(handleKeyDownEnter, ["enter"]),
    onKeyup: _withKeys(handleKeyUpSpace, ["space"])
  }, [
    (props.loading)
      ? (_openBlock(), _createBlock(_unref(ArrowPathIcon), {
          key: 0,
          class: "button__loading"
        }))
      : _renderSlot(_ctx.$slots, "default", { key: 1 })
  ], 42, _hoisted_1))
}
}

})